var exports = {
  "kL": "x127c5a35--058c2c--container",
  "qV": "x127c5a35--058c2c--skeleton",
  "Sl": "x127c5a35--058c2c--image",
  "h0": "x127c5a35--058c2c--short",
  "iM": "x127c5a35--058c2c--shimmer",
};

module.exports = exports;
